import fixedTimeCalculationTypes from './fixed-time-calculation/types';

export default {
  ...fixedTimeCalculationTypes,
};
